import * as React from "react"
import {
  ShieldIcon,
  LayoutDashboardIcon,
  FileTextIcon,
  BookOpenIcon,
  GraduationCapIcon,
  VideoIcon,
  UsersIcon,
  UserCheckIcon,
  TrendingUpIcon,
  SettingsIcon,
  CrownIcon,
  BuildingIcon,
  LayersIcon,
  GlobeIcon,
  ClipboardListIcon,
  DatabaseIcon,
} from "lucide-react"

import { NavDocuments } from "@/components/nav-documents"
import { NavMain } from "@/components/nav-main"
import { NavSecondary } from "@/components/nav-secondary"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

// Default BootMinds data - can be overridden by props
const defaultData = {
  user: {
    name: "Admin User",
    email: "admin@bootminds.com",
    avatar: "/favicon/favicon-64x64.png",
  },
  navMain: [
    {
      title: "Dashboard",
      url: "#",
      icon: LayoutDashboardIcon,
      isActive: true,
    },
    {
      title: "Resources & Insights Hub",
      url: "#",
      icon: LayersIcon,
      items: [
        {
          title: "Blog Management",
          url: "#",
          icon: FileTextIcon,
        },
        {
          title: "Resources Hub",
          url: "#",
          icon: BookOpenIcon,
        },
        {
          title: "Learning Paths",
          url: "#",
          icon: GraduationCapIcon,
        },
        {
          title: "Webinar Library",
          url: "#",
          icon: VideoIcon,
        },
      ],
    },
    {
      title: "Website Management",
      url: "#",
      icon: GlobeIcon,
      items: [
        {
          title: "Leadership & Advisory",
          url: "#",
          icon: CrownIcon,
        },
        {
          title: "About Us Content",
          url: "#",
          icon: BuildingIcon,
        },
      ],
    },
    {
      title: "User Management",
      url: "#",
      icon: UsersIcon,
    },
    {
      title: "User Approvals",
      url: "#",
      icon: UserCheckIcon,
    },
  ],
  navSecondary: [
    {
      title: "Analytics",
      url: "#",
      icon: TrendingUpIcon,
    },
    {
      title: "Settings",
      url: "#",
      icon: SettingsIcon,
    },
  ],
  documents: [
    {
      name: "Content Library",
      url: "#",
      icon: FileTextIcon,
    },
    {
      name: "Analytics Reports",
      url: "#",
      icon: ClipboardListIcon,
    },
    {
      name: "User Database",
      url: "#",
      icon: DatabaseIcon,
    },
  ],
}

export function AppSidebar({
  data = defaultData,
  setActiveTab,
  onLogout,
  ...props
}) {
  const sidebarData = data || defaultData;

  return (
    <Sidebar collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild className="data-[slot=sidebar-menu-button]:!p-1.5">
              <a href="#" onClick={(e) => { e.preventDefault(); setActiveTab?.('dashboard'); }}>
                <ShieldIcon className="h-5 w-5" />
                <span className="text-base font-semibold">BootMinds Elite</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={sidebarData.navMain} setActiveTab={setActiveTab} />
        <NavDocuments items={sidebarData.documents} setActiveTab={setActiveTab} />
        <NavSecondary items={sidebarData.navSecondary} setActiveTab={setActiveTab} className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={sidebarData.user} onLogout={onLogout} />
      </SidebarFooter>
    </Sidebar>
  );
}
